import { render, staticRenderFns } from "./LinkChip.vue?vue&type=template&id=54a7d5d0&scoped=true"
import script from "./LinkChip.vue?vue&type=script&lang=js"
export * from "./LinkChip.vue?vue&type=script&lang=js"
import style0 from "./LinkChip.vue?vue&type=style&index=0&id=54a7d5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7d5d0",
  null
  
)

export default component.exports